import { Component, OnInit } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
 
@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.css'],
    standalone: false
})
export class LogoutComponent implements OnInit {

  constructor(private msalService: MsalService) { }

  ngOnInit() {
    localStorage.clear();
    sessionStorage.clear();
    this.msalService.logout();
    
  }

}
